import { getDivisionChildren, matchDivisionByCode, type Division } from '@aurouscia/china-areas/dist/index.js'
import { MUNICIPALITY_CODES } from '@/features/master-data/const/region-cascader.ts'
import type { RegionOption, RegionSnapshot } from '@/features/master-data/types/region.ts'

export function toOption(division: Division): RegionOption {
  const children = getDivisionChildren(division.code).map(toOption)
  return {
    label: division.name,
    value: division.code,
    ...(children.length ? { children } : {})
  }
}

export function getRegionCodes(snapshot: Partial<RegionSnapshot>) {
  const codes: string[] = []
  if (snapshot.provinceCode) {
    codes.push(snapshot.provinceCode)
  }
  if (snapshot.cityCode && snapshot.cityCode !== codes.at(-1)) {
    codes.push(snapshot.cityCode)
  }
  if (snapshot.districtCode && snapshot.districtCode !== codes.at(-1)) {
    codes.push(snapshot.districtCode)
  }
  return codes
}

export function getRegionSnapshot(codes: string[]): RegionSnapshot {
  const lastCode = codes.at(-1)
  if (!lastCode) {
    throw new Error('请选择省、市、区县')
  }
  const divisions = matchDivisionByCode(lastCode)
  if (divisions.length === 0) {
    throw new Error('请选择有效的省、市、区县')
  }
  const province = divisions[0]

  if (divisions.length >= 3) {
    const city = divisions[1]
    const district = divisions[2]
    return {
      provinceCode: province.code,
      provinceName: province.name,
      cityCode: city.code,
      cityName: city.name,
      districtCode: district.code,
      districtName: district.name
    }
  }

  if (divisions.length === 2) {
    const child = divisions[1]
    if (MUNICIPALITY_CODES.has(province.code)) {
      return {
        provinceCode: province.code,
        provinceName: province.name,
        cityCode: province.code,
        cityName: province.name,
        districtCode: child.code,
        districtName: child.name
      }
    }
    return {
      provinceCode: province.code,
      provinceName: province.name,
      cityCode: child.code,
      cityName: child.name
    }
  }

  return {
    provinceCode: province.code,
    provinceName: province.name,
    cityCode: province.code,
    cityName: province.name
  }
}
